import { Box, InputBase } from '@mui/material';
// import SearchIcon from "@mui/icons-material/Search";
import FilterListIcon from '@mui/icons-material/FilterList';

const J = {
    text: '#b0c8e0',
    muted: '#a3d1ff',
    surface: '#0d1f33',
    border: '0.5px solid #294766',
};

// Search input for EntryPanel header
export default function EntrySearchInput({ value, onChange }) {
    return (
        <Box
            //
            display="flex"
            alignItems="center"
            gap={1}
            px={0.5}
            py={0.25}
            sx={{ border: J.border, borderRadius: 1, bgcolor: J.surface }}
        >
            <FilterListIcon sx={{ color: J.muted, fontSize: 14 }} />
            <InputBase
                value={value}
                onChange={(e) => onChange(e.target.value)}
                placeholder="Filter by title..."
                sx={{ color: J.text, fontSize: 12, flex: 1 }}
            />
        </Box>
    );
}
